module.exports = __webpack_public_path__ + "static/media/profileCircle.eba30548.svg";